// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetBase_wrapper__2EieR","box":"WidgetBase_box__1brKo","b":"WidgetBase_b__3_XBj","c":"WidgetBase_c__3ltPT","d":"WidgetBase_d__3J78k","e":"WidgetBase_e__z7TxP"};